import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Alert } from '@uhg-abyss/web/ui/Alert';
import { isEmpty, isUndefined } from 'lodash';
import React from 'react';

import { Table } from './components/Table';

/**
 * Widget: IreRecordDetail
 *
 * Displays record details from IRE, including a table of entity details and remediation findings.
 *
 * @param {Object} [ireRiskRecord={}] - IRE risk record containing entity details
 * @param {Object} [riskRecord={}] - Risk record containing remediation findings and trusted sources
 * @returns {JSX.Element} Rendered IRE record detail widget
 */
export function IreRecordDetail({ ireRiskRecord = {}, riskRecord = {} }) {
  const rows = ireRiskRecord?.entityDetails?.[0]?.recordResponses || [];

  const dobRemediationFindings =
    riskRecord?.ireRiskRecord?.remediationFindings?.find((item) => {
      return item.attributeType === 'dob';
    }) || {};

  const ssnRemediationFindings =
    riskRecord?.ireRiskRecord?.remediationFindings?.find((item) => {
      return item.attributeType === 'ssn';
    }) || {};

  const trustedRecordSources = riskRecord?.ireRiskRecord?.trustedRecordSources || [];

  return (
    <ErrorHandler location="src/widgets/RiskRecords/IreRecordDetail/IreRecordDetail.jsx">
      {!isUndefined(rows) && isEmpty(rows) ? (
        <Alert title="There are no record details from IRE for this risk record." variant="info" />
      ) : (
        <Table
          dobRemediationFindings={dobRemediationFindings}
          rows={rows}
          ssnRemediationFindings={ssnRemediationFindings}
          trustedRecordSources={trustedRecordSources}
        />
      )}
    </ErrorHandler>
  );
}
